import { useState } from "react";
export const Auth = ({ subTab, authData, setReGeneratePopupShow, CopY }) => {
  const [copy, setcopy] = useState(false);
  const [copy2, setcopy2] = useState(false);
  const [showsecret, setshowsecret] = useState(false);

  return (
    <>
      <div>
        <div className="commonCard">
          <div className="appInformation">
            <div className="appInformation__head">
              <h1 className="title">Access keys</h1>

              <button
                className="btn btn--primary"
                style={{
                  fontSize: "13px",
                }}
                onClick={() => {
                  setReGeneratePopupShow(true);
                }}
              >
                Regenerate
              </button>
            </div>
            <div className="appInformation__body">
              <div className="form__group">
                <label className="form__label">Client Id</label>
                <div className="form__group__ouline">
                  <div className="text">{authData?.client_id}</div>
                  {CopY && (
                    <button
                      className="btnCopy"
                      onClick={() => {
                        navigator.clipboard.writeText(authData?.client_id);
                        setcopy(true);
                        setTimeout(() => {
                          setcopy(false);
                        }, 1500);
                      }}
                    >
                      Copy
                      {!copy ? (
                        <svg
                          className="btnCopy__svg"
                          width={21}
                          height={21}
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                          <rect width={21} height={21} fill="url(#pattern0)" />
                          <defs>
                            <pattern
                              id="pattern0"
                              patternContentUnits="objectBoundingBox"
                              width={1}
                              height={1}
                            >
                              <use
                                xlinkHref="#image0_51_1041"
                                transform="scale(0.01)"
                              />
                            </pattern>
                            <image
                              id="image0_51_1041"
                              width={100}
                              height={100}
                              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEt0lEQVR4nO2db6ikUxjAz8555s5ahBJF8i+SPyEtIX/igw+kxPWB7AdqC7u0855n5m7UKz6QJG0SSYpQl5bEB6Kbf0kNtuu+zzNz2daKwo2yabN27ejMKPfOfc/szd6c58x9fnW+zD3v7XnPb845zzszPccYRVEURVEURVEURVGUcrLixIqjdeD4Pou0xTp+Jn6jh6BBGyArLjfjXTv66vJupYJ8q3X8OSB3ZTeas46eMNk3x5hRZKxOp6chghc2R7vAte80o4TF4mpw/Gv0wcX/3izS0yOxjFWbnXMB+ffYAwrLIcXRYyZpkA8HxztjDyQsY6tk7ZtNqljkB4ffIO2zjj4D5K2ANBm/8TuA/MvQmB3vNPmO1SY57v3yyKFLleOXzabO8UYa+RRUkW/vbeah2Bu0waRGxfEtwbUY+UkjHMjaawFpdyD+D0xqANJLwSm/cbZmEsAiPxBaav0KYMSyvlUdfMk6/rQ8U+FHTCo0+aTQLK+6mfOMRMC1L7VIHy96Hfnb0izF0TqTEBDYB21G1xpRjHetdfQoOPoLHP08+Gf/Wvn62x43CQFJ3Ec+cxg4fvvffUGFRAUcv7Bwo1Yh0fBr5+LMSYVEAxy/q0JYyB5Sbx/d28R1hnRFCIGsuKj8YU+XrChYRzeoEJaT9vogVAirkJiIfjDUGcIqJDY6Q4ShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoQxOkKQfhqFmoWANFcqpME3JSXEOqJA8a+7TCqsb1V9sbLy8kx8ZezwjH9XBAZ5brAvOH4v0HfSJILN2leFCpiNYXFa7PiMRbouEOCfvoz4wr78cKDE395qRmcb6eTdCiC9H3wD5lMgYT29IvSOMZunj11SGY5+mb+vaxOdU4xUfHE2pC3B+JGeNxKoZe2TQ0F6AQt7d1dZR9uC/ZF+659G0LmwJ3Ni+qjYzdenr2Bxm0VuheP2ZWL5EiNoGpeWTgVH+WB32+Brht4YJtm2GkkA0lT5NOYvyvpbR88JGMTusjTHP5r6VycYSQDy/eGA6eJFF+QzY9bxh9EHEw+20W45S9U8fLoHSPtLZ4mjj0ovynesBqQX050Z9ENvr5OKH/hQ8H5TLL+qu6pXUx3p+4RmxT7r+NnBDFIcpYUw50/trL02eHHeWvOPmDeHFryPKoGmfQY4Vm+fYdKgl9J+MmyKV5t8zpL+VXP7EWPZzJnVjC+I2urF+Qb5uGRP0emdnON47xApuyzy9bHjXFFAgzYfYPrvB6TJmps9NXasK4P+g+IbB85SeI/PsqzjG0227dDYYY82m747xB9wsvQUkvdYR9v7mRq9BtGPOZrXXNEwI0HeWgPIb8XPkPhgsqs/kvgUesnkU+APawk9NIpvjibMKOIPkbTIncRkvDr4fc5osXG2Bo7uTuIMQ8ev+33QrAj8Mtb/lvGV0I8FIFLziUU1K+4wK5a8W6k2irP6P5Sgpt9vLNJT//MR3Y9DxvcAFpf5TxtiD4miKIqiKIqiKIqiKEYQfwMZcnxHR7QXEwAAAABJRU5ErkJggg=="
                            />
                          </defs>
                        </svg>
                      ) : (
                        <svg
                          width="14"
                          height="16"
                          style={{ marginLeft: "5px" }}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M10.0007 15.1709L19.1931 5.97852L20.6073 7.39273L10.0007 17.9993L3.63672 11.6354L5.05093 10.2212L10.0007 15.1709Z"
                            fill="#26d12a"
                          ></path>
                        </svg>
                      )}
                    </button>
                  )}
                </div>
              </div>
              <div className="form__group">
                <label className="form__label">Client Secret</label>
                <div className="form__group__viewBox">
                  <div className="form__group__ouline">
                    <div
                      style={{ overflow: "hidden", textOverflow: "ellipsis" }}
                      title={showsecret && authData?.client_secret}
                      className="text"
                    >
                      {showsecret
                        ? authData?.client_secret
                        : "XXXXXXXXXXXXXXXXXXXXXXXXXXX"}
                    </div>
                    {CopY && (
                      <button
                        onClick={() => {
                          navigator.clipboard.writeText(
                            authData?.client_secret
                          );
                          setcopy2(true);
                          setTimeout(() => {
                            setcopy2(false);
                          }, 1500);
                        }}
                        className="btnCopy"
                      >
                        Copy
                        {!copy2 ? (
                          <svg
                            className="btnCopy__svg"
                            width={21}
                            height={21}
                            viewBox="0 0 21 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                          >
                            <rect
                              width={21}
                              height={21}
                              fill="url(#pattern0)"
                            />
                            <defs>
                              <pattern
                                id="pattern0"
                                patternContentUnits="objectBoundingBox"
                                width={1}
                                height={1}
                              >
                                <use
                                  xlinkHref="#image0_51_1041"
                                  transform="scale(0.01)"
                                />
                              </pattern>
                              <image
                                id="image0_51_1041"
                                width={100}
                                height={100}
                                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEt0lEQVR4nO2db6ikUxjAz8555s5ahBJF8i+SPyEtIX/igw+kxPWB7AdqC7u0855n5m7UKz6QJG0SSYpQl5bEB6Kbf0kNtuu+zzNz2daKwo2yabN27ejMKPfOfc/szd6c58x9fnW+zD3v7XnPb845zzszPccYRVEURVEURVEURVGUcrLixIqjdeD4Pou0xTp+Jn6jh6BBGyArLjfjXTv66vJupYJ8q3X8OSB3ZTeas46eMNk3x5hRZKxOp6chghc2R7vAte80o4TF4mpw/Gv0wcX/3izS0yOxjFWbnXMB+ffYAwrLIcXRYyZpkA8HxztjDyQsY6tk7ZtNqljkB4ffIO2zjj4D5K2ANBm/8TuA/MvQmB3vNPmO1SY57v3yyKFLleOXzabO8UYa+RRUkW/vbeah2Bu0waRGxfEtwbUY+UkjHMjaawFpdyD+D0xqANJLwSm/cbZmEsAiPxBaav0KYMSyvlUdfMk6/rQ8U+FHTCo0+aTQLK+6mfOMRMC1L7VIHy96Hfnb0izF0TqTEBDYB21G1xpRjHetdfQoOPoLHP08+Gf/Wvn62x43CQFJ3Ec+cxg4fvvffUGFRAUcv7Bwo1Yh0fBr5+LMSYVEAxy/q0JYyB5Sbx/d28R1hnRFCIGsuKj8YU+XrChYRzeoEJaT9vogVAirkJiIfjDUGcIqJDY6Q4ShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoShQoQxOkKQfhqFmoWANFcqpME3JSXEOqJA8a+7TCqsb1V9sbLy8kx8ZezwjH9XBAZ5brAvOH4v0HfSJILN2leFCpiNYXFa7PiMRbouEOCfvoz4wr78cKDE395qRmcb6eTdCiC9H3wD5lMgYT29IvSOMZunj11SGY5+mb+vaxOdU4xUfHE2pC3B+JGeNxKoZe2TQ0F6AQt7d1dZR9uC/ZF+659G0LmwJ3Ni+qjYzdenr2Bxm0VuheP2ZWL5EiNoGpeWTgVH+WB32+Brht4YJtm2GkkA0lT5NOYvyvpbR88JGMTusjTHP5r6VycYSQDy/eGA6eJFF+QzY9bxh9EHEw+20W45S9U8fLoHSPtLZ4mjj0ovynesBqQX050Z9ENvr5OKH/hQ8H5TLL+qu6pXUx3p+4RmxT7r+NnBDFIcpYUw50/trL02eHHeWvOPmDeHFryPKoGmfQY4Vm+fYdKgl9J+MmyKV5t8zpL+VXP7EWPZzJnVjC+I2urF+Qb5uGRP0emdnON47xApuyzy9bHjXFFAgzYfYPrvB6TJmps9NXasK4P+g+IbB85SeI/PsqzjG0227dDYYY82m747xB9wsvQUkvdYR9v7mRq9BtGPOZrXXNEwI0HeWgPIb8XPkPhgsqs/kvgUesnkU+APawk9NIpvjibMKOIPkbTIncRkvDr4fc5osXG2Bo7uTuIMQ8ev+33QrAj8Mtb/lvGV0I8FIFLziUU1K+4wK5a8W6k2irP6P5Sgpt9vLNJT//MR3Y9DxvcAFpf5TxtiD4miKIqiKIqiKIqiKEYQfwMZcnxHR7QXEwAAAABJRU5ErkJggg=="
                              />
                            </defs>
                          </svg>
                        ) : (
                          <svg
                            width="14"
                            height="16"
                            style={{ marginLeft: "5px" }}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M10.0007 15.1709L19.1931 5.97852L20.6073 7.39273L10.0007 17.9993L3.63672 11.6354L5.05093 10.2212L10.0007 15.1709Z"
                              fill="#26d12a"
                            ></path>
                          </svg>
                        )}
                      </button>
                    )}
                  </div>

                  {CopY && (
                    <button
                      onClick={() => {
                        setshowsecret(!showsecret);
                      }}
                      className={`eyebtn2 ${!showsecret ? " " : " eyeopen"}`}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
